import styled from 'styled-components';
import { Tooltip } from 'react-bootstrap';

export const Element = styled.div`
  text-align: center;
  background: #16345938;
  padding: 24px;
  border-radius: 12px;
  cursor: pointer;
  position: relative;
  height: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  border: none;
  box-shadow: 0 4px 20px rgba(26, 26, 46, 0.15);
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 8px 30px rgba(26, 26, 46, 0.25);
    transform: translateY(-4px);
  }

  img {
    width: 25%;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
  }

  i {
    font-size: 50px;
    display: block;
    margin-bottom: 10px;
    color: #1a1a2e;
  }

  span {
    font-size: 14px;
    margin-bottom: 5px;
    display: block;
    color: #374151;
  }

  h1 {
    font-size: 24px;
    font-weight: 600;
    margin-top: 20px;
    color: #1a1a2e;
  }

  small {
    color: #4b5563;
    font-size: 12px;
    margin: 10px 0;
    margin-bottom: 5px;
    display: block;
  }
`;

export const CustomTooltip = styled(Tooltip)`
  .tooltip-arrow::before {
    border-right-color: #737373 !important;
  }
  .tooltip-inner {
    background-color: #737373 !important;
  }
`;

export const ContainerProgress = styled.aside`
  position: absolute;
  right: 15px;
  top: 15px;
  z-index: 2;
`;
